import React from 'react'

type Props = {
  currentProductCount: number,
  totalResults: number,
  maxWidth: number,
  tailwindClass?: string
}

/* Returns a SVG progress bar */
function PaginationBar({currentProductCount, totalResults, maxWidth, tailwindClass}: Props): JSX.Element {
  const dynamicWidth: number = (currentProductCount / totalResults) * maxWidth
  return (
    <svg className={tailwindClass} xmlns="http://www.w3.org/2000/svg" width="210" height="3" viewBox="0 0 210 3" fill="none">
      <g clipPath="url(#clip0_3247_12728)">
        <rect width={maxWidth} height="2" transform="translate(0 0.0458984)" fill="#DFDFDF"/>
        <rect width={dynamicWidth} height="2" transform="translate(0 0.0458984)" fill="black"/>
      </g>
      <defs>
        <clipPath id="clip0_3247_12728">
          <rect width="210" height="2" fill="white" transform="translate(0 0.0458984)"/>
        </clipPath>
      </defs>
    </svg>
  )
}

export default PaginationBar